import React from 'react'

export const IconUp = (props={}) => {
	const { size=20, imgSize=20 } = props
	return <>
		<svg width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${imgSize} ${imgSize}`} stroke="currentColor" fill="currentColor" strokeWidth="0" xmlns="http://www.w3.org/2000/svg">
			<path d="M2.5 13.2467L9.74748 5.99915L16.995 13.2467L16.1117 14.1309L9.74748 7.76665L3.38337 14.1309L2.5 13.2467Z" />
		</svg>
	</>
}
